import React from 'react';

import useRegistrantContactInfoOther from './UseRegistrantContactInfoOther';
import RegistrantContactInfoForm from '../RegistrantContactInfoForm';
import Views from '../../../Views';
import ViewTemplate from '../../../components/viewTemplate/ViewTemplate';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const RegistrantContactInfoOther = () => {
  const {
    formState,
    errorState,
    onFormValueChanged,
    onValueTextPairChanged,
    onCountryChanged,
    setFormData,
    onBackButtonClicked,
    onNextButtonClicked,
    validateState,
    isCountryUSA,
    isCountryMexico,
    isCountryCanada
  } = useRegistrantContactInfoOther();

  return (
    <ViewTemplate
      viewName={Views.REGISTRANT_CONTACT_INFO_OTHER}
      onBackButtonClicked={onBackButtonClicked}
      onNextButtonClicked={onNextButtonClicked}>
      {validateState.isValidating === true && (
        <PopUpModal
          displayPopUp={true}
          maxWidth={250}
          title="Validating..."
          widthPct={50} />
      )}
      <RegistrantContactInfoForm
        formState={formState}
        errorState={errorState}
        onFormValueChanged={onFormValueChanged}
        onValueTextPairChanged={onValueTextPairChanged}
        setFormData={setFormData}
        onCountryChanged={onCountryChanged}
        isCountryUSA={isCountryUSA}
        isCountryMexico={isCountryMexico}
        isCountryCanada={isCountryCanada}
      />
    </ViewTemplate>
  );
};

export default RegistrantContactInfoOther;